import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class ChatGptPublishAllSummaryStatusUpdateService extends BaseService {
  constructor() {
    super(constants.UPDATE_CHATGPT_PUBLISH_ALL_SUMMARY_DATA_STATUS, 'ChatGptPublishAllSummaryStatusUpdateService');
  }

  handleEvent(eventName, event) {
    return this.getClient('aiadmin').post(`/chatutility/updatePublishAllSummaryStatus`, event.payload);
  }

  handleResponse(response) {
    const { data, status } = response;
    if (status === 'success' && data) {
      const notification = {
        open: true,
        type: 'success',
        message: 'All Data Published Successfully'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('chatgptSummaryUtility').setUpdateResponse();
    } else {
      const notification = {
        open: true,
        type: 'error',
        message: 'Data Not Found'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('chatgptSummaryUtility').resetStoreValues();
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
